var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-img',{attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width,"height":_vm.height,"sizes":_vm.sizes,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }